import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLanguage } from "../reduxStore/dictionarySlice";

function LanguageBridgeWithWordpress() {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleLanguageChange = (event) => {
      const lang = event.detail?.lang;

      if (lang) {
        dispatch(setLanguage(lang));
      }
    };

    window.addEventListener("siteLanguageChange", handleLanguageChange);

    return () => {
      window.removeEventListener("siteLanguageChange", handleLanguageChange);
    };
  }, [dispatch]);

  return null;
}

export default LanguageBridgeWithWordpress;
